var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCouponScissors(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V3.4375C11.25 3.85171 11.5858 4.1875 12 4.1875C12.4142 4.1875 12.75 3.85171 12.75 3.4375V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 6.3125C12.75 5.89829 12.4142 5.5625 12 5.5625C11.5858 5.5625 11.25 5.89829 11.25 6.3125V9.1875C11.25 9.60171 11.5858 9.9375 12 9.9375C12.4142 9.9375 12.75 9.60171 12.75 9.1875V6.3125Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 12.0625C12.75 11.6483 12.4142 11.3125 12 11.3125C11.5858 11.3125 11.25 11.6483 11.25 12.0625V12.2159L7.24849 8.21422C6.96288 7.9286 6.49982 7.9286 6.21421 8.21422C5.9286 8.49984 5.9286 8.96291 6.21421 9.24853L10.9657 14.0002L8.41198 16.554C7.29011 15.8913 5.82079 16.0419 4.85683 17.0058C3.71439 18.1483 3.71439 20.0007 4.85683 21.1431C5.99927 22.2856 7.85153 22.2856 8.99397 21.1431C9.95775 20.1793 10.1085 18.7103 9.44613 17.5885L12 15.0345L14.5539 17.5885C13.8915 18.7103 14.0422 20.1793 15.006 21.1431C16.1485 22.2856 18.0007 22.2856 19.1432 21.1431C20.2856 20.0007 20.2856 18.1483 19.1432 17.0058C18.1792 16.0419 16.7099 15.8913 15.588 16.554L13.0343 14.0002L17.7858 9.24853C18.0714 8.96291 18.0714 8.49984 17.7858 8.21422C17.5002 7.9286 17.0371 7.9286 16.7515 8.21422L12.75 12.2159V12.0625Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCouponScissors);
export default __webpack_public_path__ + "static/media/coupon-scissors.6dde771309972e1020980bd8e3bd45d4.svg";
export { ForwardRef as ReactComponent };